import { FC, ReactNode } from 'react'

type LucideIconProps = {
  className?: string
  size?: number
  color?: string
  'data-testid'?: string
}

export const LucideIcon: FC<LucideIconProps & { children: ReactNode }> = ({
  children,
  className,
  size = 20,
  color,
  'data-testid': testId
}) => (
  <svg
    className={className}
    data-testid={testId}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color ?? 'currentColor'}
    strokeWidth={1.7}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {children}
  </svg>
)
